import useSWR from 'swr';

import { HTTP_SUCCESS_OK } from '../helpers/http';

const useFetch = <T>(
  url: string
): {
  data: T;
  error: any;
  loading: boolean;
} => {
  const { data, error } = useSWR<T>(
    url,
    async (url) => {
      const res = await fetch(url);

      if (res.status === HTTP_SUCCESS_OK) {
        return await res.json();
      } else if (res.status >= 400) {
        throw {
          status: res.status,
        };
      }
    },
    {
      // Avoid refresh during 5 minutes
      dedupingInterval: 5 * 60 * 1000,
      errorRetryCount: 3,
    }
  );

  return { data, error, loading: !error && !data };
};

export default useFetch;
